import React, { Component } from "react";
import {withTranslation} from "react-i18next";
import i18next from "../../utils/lang/i18n";
import { fni18n, } from "../../services/commonService";
import AuthenticationService from "./AuthenticationService.js";
import {GetLoggedInUserName} from "../../services/commonService.js";

// MUI
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import CheckBox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Alert from "@mui/material/Alert";
import Stack from "@mui/material/Stack";
import Paper from "@mui/material/Paper";
import Divider from '@mui/material/Divider';
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

//ICON
import AccountCircle from '@mui/icons-material/AccountCircle';
import LockIcon from '@mui/icons-material/Lock';


import icon_ID from "../../assets/images/icon/login_id.png";
import icon_PW from "../../assets/images/icon/login_pw.png";


import { amber, orange } from "@mui/material/colors";
import { styled, createTheme } from "@mui/material/styles";
import { getAPI, putAPI } from "../../services/commonService";
import { API } from "../../config";
import { withStyles } from "@material-ui/core/styles";

//IMG
import login_BG from "../../assets/images/bg/login_bg.png";
import logo_black from "../../assets/images/logo/ezcams_black.png";
import UConfirmDialog from "../../components/mui/UConfirmDialog";
import UAlertDialog from "../../components/mui/UAlertDialog";


// [공통] 버튼
const ColorButton = styled(Button)(({ theme }) => ({
  color: theme.palette.getContrastText(orange[800]),
  backgroundColor: "#8D7C57",
  "&:hover": {
    backgroundColor: "#CEAE6A",
  },
}));

const theme = createTheme({
  palette: {
    secondary: {
      main: "#78909c",
      contrastText: "#ffffff",
    },
  },
});

const styles = {
  container: {
    
    backgroundImage: `url(${login_BG})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
};

const styless = theme => ({
  textBox: {
    // '& .MuiInputBase-root.MuiOutlinedInput-root':{
    //   border:"1px solid #dddddd",
    // },
    // '& .MuiInputBase-root.MuiOutlinedInput-root:hover': {
    //   border:"1px solid #CEAE6A",
    // },
    '& .MuiOutlinedInput-root':{
      borderRadius:"6px 6px 0 0"
    },
    '& .MuiInput-underline:before': {
      borderBottom: 'none',
    },
    '& .MuiInput-underline:after': {
      borderBottom: 'none',
    },
    '& .MuiInput-underline:hover:before': {
      borderBottom: 'none',
    },
    // '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
    //   borderColor: 'red',
    // },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#CEAE6A',
    },
  },
  textBox2:{
    '& .MuiOutlinedInput-root':{
      border:"none",
      borderRadius:"0 0 6px 6px"
    },
    '& .MuiInput-underline:before': {
      borderTop: 'none',
    },
    '& .MuiInput-underline:after': {
      borderTop: 'none',
    },
    '& .MuiInput-underline:hover:before': {
      borderTop: 'none',
    },
    // '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
    //   borderColor: 'red',
    // },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#CEAE6A',
    },
  }
});

class InitPwdPage extends Component {
  
  constructor(props) {
    super(props);

    this.state = {
      username: localStorage.getItem("authenticatedUser") || "",
      branch: localStorage.getItem("authenticatedBranch") || "",
      password: "",
      newPwd: "",
      newPwdChk: "",
      token: localStorage.getItem("token") || "",
      showSuccessMessage: false,
      errorMsg: "",
      errorPopupOpen: false,
      pwdChg: false,
      confirmMsg: "",
      confirmPopupOpen: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.loginClicked = this.loginClicked.bind(this);
    this.onChangeLang = this.onChangeLang.bind(this);
    this.handleErrorOpen = this.handleErrorOpen.bind(this);
    this.handleErrorClose = this.handleErrorClose.bind(this);
    this.setErrorMsg = this.setErrorMsg.bind(this);
    this.handleConfirmOpen = this.handleConfirmOpen.bind(this);
    this.handleConfirmClose = this.handleConfirmClose.bind(this);
    this.handelConfirmEvent = this.handelConfirmEvent.bind(this);
    this.setConfirmMsg = this.setConfirmMsg.bind(this);
  }

  handleChange(e) {
    this.setState({
      [e.target.name]: e.target.value,
    });
  }

  loginClicked() {
    let data = {
      userId : this.state.username,
      branchCd : this.state.branch,
      newPwd : this.state.newPwd,
      newPwdChk : this.state.newPwdChk
    }

    getAPI(API.OPER.INITPWD+'/pwdCheck', data).then((res)=>{
        if(res.data==-2){
          this.setErrorMsg("새 암호가 필요합니다.");
          this.handleErrorOpen();
        }else if(res.data==-3){
          this.setErrorMsg("새 암호 확인이 필요합니다");
          this.handleErrorOpen();
        }else if(res.data==-4){
          this.setErrorMsg("새 비밀번호와 새 비밀번호 확인이 다릅니다");
          this.handleErrorOpen();
        }else if(res.data==-5){
          this.setErrorMsg("초기 비밀번호와 동일한 비밀번호로 설정할 수 없습니다");
          this.handleErrorOpen();
        }else if(res.data==0){
          this.setConfirmMsg("비밀번호를 변경하시겠습니까?");
          this.handleConfirmOpen();
        }
    })
  }
  
  onChangeLang(e) {
    i18next.changeLanguage(e.target.value);
  }

  handleErrorOpen(){
    this.setState({ errorPopupOpen : true })
  }

  handleErrorClose(){
    this.setState({ errorPopupOpen : false })
    if(this.state.pwdChg){
      this.props.history.push(`/main/dashboard`);
    }
  }

  setErrorMsg(e) {
    this.setState({ errorMsg : e })
  }

  handleConfirmOpen(){
    this.setState({ confirmPopupOpen : true })
  }

  handleConfirmClose(){
    this.setState({ confirmPopupOpen : false })
  }
  
  handelConfirmEvent(){
    try{
      let data = {
        userId : this.state.username,
        storeCd : this.state.branch,
        newPwd : this.state.newPwd,
        newPwdChk : this.state.newPwdChk
      }
      putAPI(API.OPER.INITPWD, data).then((res)=>{
        if(res.data.code === 200){
          // this.setErrorMsg(res.data.message || "Processing completed.");
          this.setErrorMsg("처리가 완료되었습니다");
          this.handleErrorOpen();
          this.setState({ pwdChg: true })
        }else {
          // this.setErrorMsg(res.data.message || "Processing failed.");
          this.setErrorMsg("처리가 실패하였습니다");
          this.handleErrorOpen();
        }
      })
    }catch(error){
      console.log(error)
    }finally{
      this.handleConfirmClose();
    }
  }

  setConfirmMsg(e){
    this.setState({ confirmMsg : e })
  }

  render() {
    const {t, classes} = this.props;
    return (
      <Container sx={styles.container} maxWidth={false}>
        <Box
          sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100vh',
              position: 'relative', // position 추가
          }}
        >
          <Paper
            variant="elevation"
            elevation={6}
            sx={{
              borderRadius: "20px",
              padding: 2,
              // minHeight: "44vh",
              // minWidth: "21vh",
              minHeight: "477px",
              minWidth: "400px",
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
            }}
          > 
          {/* LOGO */}
          <Box sx={{
              height:50,
              backgroundImage:`url(${logo_black})`,
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center center',
              mt:"50px",
              mb:"40px",
            }}>
          </Box>
          <Stack
              direction="row"
              divider={<Divider orientation="vertical" flexItem />}
              spacing={2}
              alignItems="center"
              justifyContent="center"
            >
            <Stack direction="column" sx={{ width: "310px" }}>
                <TextField
                  sx={{p:0,m:0,}}
                  // label="ID"
                  margin="normal"
                  required
                  fullWidth
                  autoFocus
                  placeholder="ID"
                  name="username"
                  value={this.state.username}
                  onChange={this.handleChange}
                  className={classes.textBox}
                  InputProps={{
                    startAdornment: (
                      <Box sx={{ marginRight: '10px',mt:"5px"}}>
                        {/* <AccountCircle /> */}
                        <img src={icon_ID} alt="" />
                      </Box>
                    )
                  }}
                />
                <TextField
                  sx={{p:0,mt:1,}}
                  // label="Password"
                  margin="normal"
                  type="password"
                  required
                  fullWidth
                  autoComplete="current--password"
                  placeholder="New Password"
                  name="newPwd"
                  value={this.state.newPwd}
                  onChange={this.handleChange}
                  className={classes.textBox2}
                  InputProps={{
                    startAdornment: (
                      <Box sx={{ marginRight: '10px',mt:"5px"}}>
                        {/* <LockIcon /> */}
                        <img src={icon_PW} alt="" />
                      </Box>
                    )
                  }}
                />
                <TextField
                  sx={{p:0,mt:0,}}
                  // label="Password"
                  margin="normal"
                  type="password"
                  required
                  fullWidth
                  autoComplete="current--password"
                  placeholder="New Password Check"
                  name="newPwdChk"
                  value={this.state.newPwdChk}
                  onChange={this.handleChange}
                  className={classes.textBox2}
                  InputProps={{
                    startAdornment: (
                      <Box sx={{ marginRight: '10px',mt:"5px"}}>
                        {/* <LockIcon /> */}
                        <img src={icon_PW} alt="" />
                      </Box>
                    )
                  }}
                />
                <Stack sx={{ width: "100%" }} spacing={2}>
                    <Alert severity="error">
                      {fni18n(`초기 비밀번호로 로그인하셨습니다.`)}
                      <br />
                      {fni18n(`비밀번호를 변경해주세요.`)}
                    </Alert>
                </Stack>
                <ColorButton
                  type="submit"
                  fullWidth
                  variant="contained"
                  sx={{ mt: 5, mb: 1, height:50 }}
                  onClick={this.loginClicked}
                >
                {fni18n(`저장`)}
                </ColorButton>               
              </Stack>
          </Stack>
          </Paper>
          <UConfirmDialog
                message={this.state.confirmMsg}
                open={this.state.confirmPopupOpen}
                onClose={this.andleConfirmClose}
                onClickOk={this.handelConfirmEvent}
            />
          <UAlertDialog
            message={this.state.errorMsg}
            open={this.state.errorPopupOpen}
            onClose={this.handleErrorClose}
          />
        </Box>
      </Container>
    );
  }
}

export default withStyles(styless)(withTranslation()(InitPwdPage));